import React from 'react'

export const BackIcon = () => (
  <button><span>Movies </span></button>
)
